// test2225
(2225 && 0);
